import React from "react";

// const loginForm = React.lazy(() => import("views/LoginForm"));
const Dashboard = React.lazy(() => import("views/Dashboard/dashboard"));
const eventDashboard = React.lazy(() => import("views/aims/aimseventdashboard/eventdashboard"));
const userdetails = React.lazy(() =>
  import("views/UsersAndProfiles/userdetails")
);
const profiledetails = React.lazy(() =>
  import("views/UsersAndProfiles/profiledetails")
);
const auditLog = React.lazy(() => import("views/Audit/auditlogs"));
const loggedinUsers = React.lazy(() => import("views/Audit/loggedinusers"));
const logInDetails = React.lazy(() => import("views/Audit/logindetails"));

const universities = React.lazy(() =>
  import("views/configurations/universities/universities")
);
const academicinstitutes = React.lazy(() =>
  import("views/configurations/academicinstitutes/academicinstitutes")
);
const aiuniversityassociation = React.lazy(() =>
  import("views/configurations/aiuniversityassociation/aiuniversityassociation")
);
const rozodetails = React.lazy(() =>
  import("views/configurations/rozodetails/rozodetails")
);
const rozouniversityassociation = React.lazy(() =>
  import("views/configurations/rozouniversityassociation/rozouniversityassociation")
);
const coursedetails = React.lazy(() =>
  import("views/configurations/coursedetails/coursedetails")
);


const feesbreakup = React.lazy(() =>
  import("views/configurations/feesbreakup/feesbreakup")
);

const accomedationdetails = React.lazy(() =>
  import("views/configurations/accomedationdetails/accomedationdetails")
);

const scholarships = React.lazy(() =>
  import("views/configurations/scholarships/scholarships")
);

const trackstudents = React.lazy(() =>
  import("views/iccr/trackstudents/trackstudents")
);

const monitorpayment = React.lazy(() =>
  import("views/iccr/monitorpayment/monitorpayment")
);
const quotaapproval = React.lazy(() =>
  import("views/iccr/quotaapproval/quotaapproval")
);
const foreignmissionapproval = React.lazy(() =>
  import("views/iccr/foreignmissionapproval/foreignmissionapproval")
);
const traveldetailsapproval = React.lazy(() =>
  import("views/iccr/traveldetailsapproval/traveldetailsapproval")
);
const wardsprogress = React.lazy(() =>
  import("views/iccr/wardsprogress/wardsprogress")
);
const orientationsessions = React.lazy(() =>
  import("views/institutes/orientationsessions/orientationsessions")
);

const academicprogress = React.lazy(() =>
  import("views/institutes/academicprogress/academicprogress")
);
const studentarraivals = React.lazy(() =>
  import("views/institutes/studentarraivals/studentarraivals")
);
const placeofstay = React.lazy(() =>
  import("views/institutes/placeofstay/placeofstay")
);
const graduationofstudent = React.lazy(() =>
  import("views/institutes/graduationofstudent/graduationofstudent")
);
const studentexitreport = React.lazy(() =>
  import("views/institutes/studentexitreport/studentexitreport")
);
const paymentreceiptconfirmation = React.lazy(() =>
  import("views/institutes/paymentreceiptconfirmation/paymentreceiptconfirmation")
);

const studentAttendance = React.lazy(() =>
  import("views/institutes/studentattendancereport/studentattendancereport")
);

const sanctionofpayment = React.lazy(() =>
  import("views/rozo/sanctionofpayment/sanctionofpayment")
);

const paytostudent = React.lazy(() =>
  import("views/rozo/paytostudent/paytostudent")
);

const detailsofpayment = React.lazy(() =>
  import("views/rozo/detailsofpayment/detailsofpayment")
);

const academicpaymentrelease = React.lazy(() =>
  import("views/rozo/academicpaymentrelease/academicpaymentrelease")
);
const scholarshipsuspendprovision = React.lazy(() =>
  import("views/rozo/scholarshipsuspendprovision/scholarshipsuspendprovision")
);
const scholarshipterminationrecord = React.lazy(() =>
  import("views/rozo/scholarshipterminationrecord/scholarshipterminationrecord")
);
const paymentbulkupload = React.lazy(() =>
  import("views/rozo/paymentbulkupload/paymentbulkupload")
);
const scholarshipapplication = React.lazy(() =>
  import("views/students/scholarshipapplication/scholarshipapplication")
);
const confirmacceptance = React.lazy(() =>
  import("views/students/confirmacceptance/confirmacceptance")
);
const arraivalconfirmation = React.lazy(() =>
  import("views/students/arraivalconfirmation/arraivalconfirmation")
);
const icecontactconfirmation = React.lazy(() =>
  import("views/students/icecontactconfirmation/icecontactconfirmation")
);
const traveldetails = React.lazy(() =>
  import("views/students/traveldetails/traveldetails")
);
const students = React.lazy(() =>
  import("views/configurations/students/students")
);

const schemewise = React.lazy(() =>
  import("views/reports/schemewiseexpenditure/schemewiseexpenditure")
);

const studentlive = React.lazy(() =>
  import("views/reports/studentlivestatus/studentlivestatus")
);

const delhistudent = React.lazy(() =>
  import("views/configurations/delhistudents/delhistudents")
);

const studentexpenditure = React.lazy(() =>
  import("views/reports/expenditurereport/expenditurereport")
);

const reportExpenditure = React.lazy(() =>
  import("views/reports/expenditure/expenditure")
);

const expendituresummary = React.lazy(() =>
  import("views/reports/expendituresummary/expendituresummary")
);

const ledger = React.lazy(() =>
  import("views/reports/ledger/ledger")
);

const jr = React.lazy(() =>
  import("views/institutes/joiningreport/joiningreport")
);

const docapprove = React.lazy(() =>
  import("views/rozo/studentdocumentapprove/studentdocumentapprove")
);

const processpayment = React.lazy(() =>
  import("views/rozo/processpayment/processpayment")
);
const processpaymentnonedit = React.lazy(() =>
  import("views/rozo/processpayment/processpaymentnonedit")
);


const coursefeesdetailsnonedit = React.lazy(() =>
  import("views/rozo/coursefeesdetails/coursefeesdetailsnonedit")
);

const accommodationApprove = React.lazy(() =>
  import("views/rozo/studentaccomadationapprove/studentaccomadationapprove")
);

const coursefeesdetailsprocessed = React.lazy(() =>
  import("views/rozo/coursefeesdetails/coursefeesdetails")
);

const recordstudentwelfare = React.lazy(() =>
  import("views/rozo/studentWelfare/studentwelfare")
);

const studentwelfarereport = React.lazy(() =>
  import("views/reports/studentwelfarereport/studentwelfarereport")
);
const paymentreceiptconfirmationnoedit = React.lazy(() =>
  import("views/institutes/paymentreceiptconfirmation/paymentreceiptconfirmationnoedit")
);

const eventdetails = React.lazy(() =>
  import("views/aims/eventdetails/eventdetails")
);

const artistManagement = React.lazy(() =>
  import("views/aims/artistmanagement/artistmanagement")
);

const contacts = React.lazy(() =>
  import("views/aims/contacts/contacts")
);

const entity = React.lazy(() =>
  import("views/aims/entity/entity")
);

const inventory = React.lazy(() =>
  import("views/aims/inventory/inventory")
);
const inventorylist = React.lazy(() =>
  import("views/aims/inventory/inventorylist")
);
const configurations = React.lazy(() =>
  import("views/aims/configurations/configurations")
);
const iccmissionassociation = React.lazy(() =>
  import("views/aims/iccmissionassociation/iccmissionassociation")
);
const operationalreports = React.lazy(() =>
  import("views/scholarshipoperationalreport/scholarshipoperationalreport")
);

const inventoryreport = React.lazy(() =>
  import("views/aims/inventory/inventoryreport")
);


const budgetalloc = React.lazy(() =>
  import("views/aims/budgetalloc/budgetalloc")
);

const staff = React.lazy(() =>
  import("views/aims/staff/staff")
);

const eventrequest = React.lazy(() =>
  import("views/aims/eventrequest/eventrequest")
);

const eventcost = React.lazy(() =>
  import("views/aims/eventcost/eventcost")
);

const eventprocessing = React.lazy(() =>
  import("views/aims/eventprocessings/eventprocessings")
);

const entityperformance = React.lazy(() =>
  import("views/aims/entityperformance/entityperformance")
);

const budgetheads = React.lazy(() =>
  import("views/aims/budgetheads/budgetheads")
);

const country = React.lazy(() =>
  import("views/aims/country/country")
);

const entitytypes = React.lazy(() =>
  import("views/aims/entitytypes/entitytypes")
);

const eventcompstatus = React.lazy(() =>
  import("views/aims/eventcompstatus/eventcompstatus")
);

const eventtype = React.lazy(() =>
  import("views/aims/eventtype/eventtype")
);

const stafftype = React.lazy(() =>
  import("views/aims/stafftype/stafftype")
);

const inventorycategory = React.lazy(() =>
  import("views/aims/inventorycategory/inventorycategory")
);

const entityperformancecategory = React.lazy(() =>
  import("views/aims/entityperformancecategory/entityperformancecategory")
);

const eventdetailscategory = React.lazy(() =>
  import("views/aims/eventdetailscategory/eventdetailscategory")
);

const artistgenre = React.lazy(() =>
  import("views/aims/artistgenre/artistgenre")
);

const artistcategory = React.lazy(() =>
  import("views/aims/artistcategory/artistcategory")
);

const artistprofile = React.lazy(() =>
  import("views/aims/artistprofile/artistprofile")
);

const dummy = React.lazy(() =>
  import("views/aims/dummy/dummy")
);

const artdummy = React.lazy(() =>
  import("views/aims/artdummy/artdummy")
);

const artdummynew = React.lazy(() =>
  import("views/aims/artdummynew/artdummynew")
);

const artistlist = React.lazy(() =>
  import("views/aims/artistlist/artistlist")
);

const visadetail = React.lazy(() =>
  import("views/mission/visadetailupload/visadetailupload")
);

const missionstudent = React.lazy(() =>
  import("views/mission/missionstudents/missionstudents")
);

const missionstudentnewtry = React.lazy(() =>
  import("views/mission/missionstudents/missionstudentnewtry")
);

const missiontravel = React.lazy(() =>
  import("views/mission/traveldetailupload/traveldetailupload")
);

const missionledger = React.lazy(() =>
  import("views/mission/missionledger/missionledger")
);

const countryvisadetail = React.lazy(() =>
  import("views/country/countryvisadetailupload/coutryvisadetailupload")
);

const countrystudent = React.lazy(() =>
  import("views/country/countrystudents/countrystudents")
);

const countrytravel = React.lazy(() =>
  import("views/country/countrytraveldetailupload/countrytraveldetailupload")
);

const countryledger = React.lazy(() =>
  import("views/country/countryledger/countryledger")
);

const studentdeptmentupdate = React.lazy(() =>
  import("views/iccr/studentdept/studentdept")
);

const culturalfactsheet = React.lazy(() =>
  import("views/aims/culturalfactsheet/culturalfactsheet")
);

const eventrequestreport = React.lazy(() =>
  import("views/aims/eventrequestreport/eventrequestreport")
);

const handingoverroles = React.lazy(() =>
  import("views/aims/handingoverroles/handingoverroles")
);

const handingoverreport = React.lazy(() =>
  import("views/aims/handingoverreport/handingoverreport")
);
const surveyquestions = React.lazy(() =>
  import("views/aims/surveyquestionsdetails/surveyquestions")
);
const artistgrp = React.lazy(() =>
  import("views/artist/artistGroup/artistgroupdetails")
);
const surveyrank = React.lazy(() => 
import("views/aims/surveyquestionsdetails/rankdashboard"));

const editartistdetails = React.lazy(() =>
  import("views/aims/editartistdetails/editartistdetails"));

const artistGroupAssocMemberView = React.lazy(() =>
  import("views/artist/artistGroup/ArtistGroupAssocMemberView"));

const artistdetails = React.lazy(() =>
  import("views/aims/artistdetails/artistdetails")
);
const exitgroup = React.lazy(() =>
  import("views/artist/artistGroup/ArtistGroupAssocMemberView")
);
const recordMonthlyReceiptExpenditure = React.lazy(() =>
  import("views/finance/recordmonthlyreceiptexpenditure/RecordMonthlyReceiptExpenditure")
);

const entitycontientasso = React.lazy(() =>
  import("views/ams/artistsmissionasso/entitycontientsasso")
);
const divisions = React.lazy(() =>
  import("views/ams/artistsmissionasso/divisions")
);

const notifynearbyentity = React.lazy(() =>
  import("views/ams/notifynearbyentity/notifynearbyentity")
);

const guidelines = React.lazy(() =>
  import("views/ams/guidelines/guidelines")
);

const amsreports = React.lazy(() =>
  import("views/ams/amsreports/amsreports")
);

const categorytypewisereport = React.lazy(() =>
  import("views/ams/amsreports/categorytypewisereports")
);

const budgettreemap = React.lazy(() =>
  import("views/ams/amsreports/budgettreemap")
);


const aimsOverallReport = React.lazy(() => import("views/aims/reports/overall/AimsOverallReport"));
const aimsExpenseAndReceiptDashboard = React.lazy(() => import("views/aims/reports/overall/AimsExpenseAndReceiptDashboard"));


const monthlyexpenditurereports = React.lazy(() =>
  import("views/aims/reports/monthlyexpenditurereports")
);
const monthlyreceiptreports = React.lazy(() =>
  import("views/aims/reports/monthlyreceiptreports")
);

const culturalFactSheetv2 = React.lazy(() => import("views/aims/culturalfactsheet/CulturalFactSheetv2"));

const monthlyreport = React.lazy(() => import("views/aims/monthlyreport/monthlyreport"));

const flashmessagedetails = React.lazy(() => import("views/ams/flashmessagedetails/flashmessagedetails"));

const chat = React.lazy(() => import("views/GenericChat/GenericChat"));
const chatreport = React.lazy(() => import("views/ChatReport/chatreport"));
const routes = [
  { id: "-1", path: "/dashboard", exact: true, name: "dashboard", component: Dashboard },
  { id: "0", path: "/dashboard", name: "Dashboard", component: Dashboard },
  { id: "1", component: userdetails },
  { id: "2", component: profiledetails },
  { id: "3", component: auditLog },
  { id: "4", component: loggedinUsers },
  { id: "5", component: logInDetails },
  { id: "6", component: universities },
  { id: "7", component: academicinstitutes },
  { id: "8", component: aiuniversityassociation },
  { id: "9", component: rozodetails },
  { id: "10", component: rozouniversityassociation },
  { id: "11", component: coursedetails },
  { id: "12", component: feesbreakup },
  { id: "13", component: accomedationdetails },
  { id: "14", component: scholarships },
  { id: "15", component: trackstudents },
  { id: "16", component: monitorpayment },
  { id: "17", component: quotaapproval },
  { id: "18", component: foreignmissionapproval },
  { id: "19", component: traveldetailsapproval },
  { id: "20", component: wardsprogress },
  { id: "21", component: orientationsessions },
  { id: "22", component: academicprogress },
  { id: "23", component: studentarraivals },
  { id: "24", component: placeofstay },
  { id: "25", component: graduationofstudent },
  { id: "26", component: studentexitreport },
  { id: "27", component: paymentreceiptconfirmation },
  { id: "28", component: sanctionofpayment },
  { id: "29", component: paytostudent },
  { id: "30", component: detailsofpayment },
  { id: "31", component: academicpaymentrelease },
  { id: "32", component: scholarshipsuspendprovision },
  { id: "33", component: scholarshipterminationrecord },
  { id: "34", component: paymentbulkupload },
  { id: "35", component: scholarshipapplication },
  { id: "36", component: confirmacceptance },
  { id: "38", component: arraivalconfirmation },
  { id: "39", component: icecontactconfirmation },
  { id: "40", component: traveldetails },
  { id: "41", component: students },
  { id: "42", component: studentAttendance },
  { id: "43", component: schemewise },
  { id: "44", component: studentlive },
  { id: "45", component: delhistudent },
  { id: "46", component: studentexpenditure },
  { id: "47", component: expendituresummary },
  { id: "48", component: reportExpenditure },
  { id: "49", component: ledger },
  { id: "50", component: jr },
  { id: "51", component: docapprove },
  { id: "52", component: processpayment },
  { id: "53", component: accommodationApprove },
  { id: "101", component: coursefeesdetailsprocessed },
  { id: "52", component: processpayment },
  { id: "54", component: processpaymentnonedit },
  { id: "55", component: coursefeesdetailsnonedit },
  { id: "102", component: recordstudentwelfare },
  { id: "103", component: studentwelfarereport },
  { id: "104", component: entitytypes },
  { id: "105", component: entity },
  { id: "106", component: stafftype },
  { id: "107", component: staff },
  { id: "108", component: budgetheads },
  { id: "109", component: budgetalloc },
  { id: "110", component: eventtype },
  { id: "111", component: eventdetailscategory },
  { id: "112", component: eventdetails },
  { id: "113", component: eventcompstatus },
  { id: "114", component: eventrequest },
  { id: "116", component: contacts },
  { id: "117", component: inventorycategory },
  { id: "118", component: inventory },
  { id: "119", component: entityperformancecategory },
  { id: "120", component: entityperformance },
  { id: "121", component: artistgenre },
  { id: "122", component: artistcategory },
  { id: "124", component: artistprofile },
  { id: "123", component: artistManagement },
  { id: "125", component: artistlist },
  { id: "58", component: missionstudent },
  { id: "59", component: visadetail },
  { id: "60", component: missiontravel },
  { id: "61", component: missionledger },
  { id: "62", component: countrystudent },
  { id: "63", component: countryvisadetail },
  { id: "64", component: countrytravel },
  { id: "65", component: countryledger },
  { id: "66", component: studentdeptmentupdate },
  { id: "67", component: handingoverroles },
  { id: "68", component: handingoverreport },
  { id: "69", component: monthlyexpenditurereports },
  { id: "70", component: monthlyreceiptreports },
  { id: "126", component: culturalFactSheetv2 },
  { id: "127", component: eventrequestreport },
  { id: "128", component: artistdetails },
  { id: "129", component: editartistdetails },
  { id: "130", component: exitgroup },
  { id: "131", component: entitycontientasso },
  { id: "132", component: notifynearbyentity},
  { id: "133", component: guidelines},
  { id: "134", component: amsreports},
  { id: "135", component: categorytypewisereport},
  { id: "136", component: budgettreemap},
  { id: "137", component: monthlyreport},
  { id: "138", component: flashmessagedetails},
  { id: "201", component: eventDashboard },
  { id: "202", component: inventorylist },
  { id: "203", component: inventoryreport },
  { id: "204", component: configurations },
  { id: "205", component: iccmissionassociation },
  { id: "206", component: operationalreports },
  { id: "207", component: surveyquestions },
  { id: "208", component: surveyrank },
  { id: "209", component: artistgrp },
  { id: "210", component: chat },
  { id: "211", component: chatreport },
  { id: "300", component: recordMonthlyReceiptExpenditure },
  { id: "301", component: divisions },
  { id: "302", component: aimsOverallReport },
  { id: "303", component: aimsExpenseAndReceiptDashboard },
  
];

export default routes;
